import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-installer-category-icon',
    templateUrl: './installer-category-icon.component.html',
    styleUrls: ['./installer-category-icon.component.scss'],
    standalone: false
})
export class InstallerCategoryIconComponent {
  @Input()
  public categoryValue: string;
}
